import { InvestmentsPage, InvestmentPageActionTypes, SET_INVESTMENT_PAGE_DATE } from './types'
import { now, endOfMonth } from '../../../config/dayjsConfig'

const initialState: InvestmentsPage = {
  date: endOfMonth(now())
}

const investmentsPageReducer = (state = initialState, action: InvestmentPageActionTypes) => {
  switch (action.type) {
    case SET_INVESTMENT_PAGE_DATE:
      return { ...state, date: action.payload }
    default:
      return state
  }
}

export default investmentsPageReducer
